import { gql } from "@apollo/client";
import CompanySubscription from "~/lib/queries/fragments/CompanySubscription";
import StripeChargeFields from "~/lib/queries/fragments/StripeChargeFields";
import StripePlanFields from "~/lib/queries/fragments/StripePlanFields";

export default gql`
  mutation ChangeSubscriptionPlan($stripePlanId: String!) {
    changeSubscriptionPlan(stripePlanId: $stripePlanId) {
      stripePlan {
        ...StripePlanFields
      }
      ...CompanySubscription
    }
  }

  ${CompanySubscription}
  ${StripeChargeFields}
  ${StripePlanFields}
`;
